import {
  publishEvent,
  Constants,
  CallResult,
  PhoneCall,
  CallInfo,
  Contact,
  PhoneCallAttributes,
} from '@salesforce/scv-connector-base';
import type { Call } from '@entities/call';
import { CallTypes } from '@entities/call';
import { Logger } from '@main/utils/logger';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import type { DisconnectedTransferCallEventPublisher } from './disconnect-transfer-call.usecase';

export class DisconnectedTransferCallPublisher
  implements DisconnectedTransferCallEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(call: Call): Promise<void> {
    const mapCallType = (type: CallTypes): Constants.CALL_TYPE => {
      return type === CallTypes.INBOUND
        ? Constants.CALL_TYPE.INBOUND
        : type === CallTypes.TRANSFER
        ? Constants.CALL_TYPE.TRANSFER
        : type === CallTypes.ADD_PARTICIPANT
        ? Constants.CALL_TYPE.ADD_PARTICIPANT
        : Constants.CALL_TYPE.OUTBOUND;
    };

    const phoneCall = new PhoneCall({
      callId: call.id,
      callType: mapCallType(call.type),
      phoneNumber: call.type === CallTypes.INBOUND ? call.from : call.to,
      state: Constants.CALL_STATE.ENDED,
      callInfo: new CallInfo({
        isOnHold: false,
        isRecordingPaused: false,
        isMuted: false,
      }),
      contact: new Contact({}),
      callAttributes: new PhoneCallAttributes({}),
      reason: Constants.HANGUP_REASON.PHONE_CALL_ENDED,
      closeCallOnError: true,
      agentStatus: '',
    });

    const callResult = new CallResult({
      call: phoneCall,
    });

    this.logger.info('Publisher: Transfer Call disconnected', {
      action: 'DisconnectedCall',
      ...call,
    });

    publishEvent({
      eventType: 'PARTICIPANT_REMOVED',
      payload: callResult,
      registerLog: false,
    });
    const busIframe = await BusIframe.getIframe();
    setTimeout(() => {
      const busEvent: BusEvent = {
        type: 'DIALER.MUTE',
        payload: {
          shouldMute: false,
        },
      };

      return BusEventsPromisifier.promisifyFireAndForgetEvent({
        target: busIframe,
        event: busEvent,
      });
    }, 6000);
  }
}
